document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-upsell-bundle]');

  for (const section of sections) {
    const button = section.querySelector('[data-upsell-bundle-cta]');
    if (!button) continue;

    // Follow the PDP size picker: show that variant's price line, cart items and availability.
    const productId = document.querySelector('[data-product-section]')?.dataset.productId;
    const options = [...section.querySelectorAll('[data-upsell-bundle-option]')];
    if (productId && options.length > 1 && typeof subscribe !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ productId: changedId, variant }) => {
        if (changedId !== productId || !variant) return;
        const option = options.find((el) => el.dataset.upsellBundleOption === String(variant.id));
        if (!option) return;

        for (const el of options) el.classList.toggle('hidden', el !== option);
        section.dataset.variantIds = option.dataset.variantIds;
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.setAttribute('aria-disabled', String(!available));
      });
    }

    button.addEventListener('click', async () => {
      if (button.disabled) return;

      const variantIds = JSON.parse(section.dataset.variantIds);
      const items = variantIds.map((id) => ({ id, quantity: 1 }));
      const cartDrawer = document.querySelector('cart-drawer');

      if (!cartDrawer) {
        button.disabled = true;
        try {
          await CartAPI.addMultiple(items);
        } catch (error) {
          console.error('[UpsellBundle] add failed:', error);
        } finally {
          button.disabled = false;
        }
        return;
      }

      cartDrawer.open();
      // No error handling here: the drawer's mutation loop has already painted
      // the localised message into its own error slot.
      await cartDrawer.addItems(items, button);
    });
  }
});
